const contactAf = {
  breadcrumbs: { home: 'کور', contact: 'اړیکه' },
  hero: {
    title: 'موږ سره اړیکه ونیسئ',
    subtitle: 'موږ دلته یو چا د هر ډول پوښتنې، فیډبیک یا ملاتړ لپاره مرسته کوو'
  },
  quick: {
    title: 'ژر مرسته ترلاسه کړئ',
    actions: {
      liveChat: { title: 'ژوندی چټ', desc: 'ژر مرسته ترلاسه کړئ', cta: 'چټ پیل کړئ' },
      helpCenter: { title: 'د مرستې مرکز', desc: 'د عامو پوښتنو ځوابونه', cta: 'مرسته وګورئ' },
      business: { title: 'د سوداګرۍ پوښتنه', desc: 'شراکتونه او همکاري', cta: 'موږ سره اړیکه ونیسئ' }
    }
  },
  info: {
    title: 'د اړیکې معلومات',
    service: { title: 'د پیرودونکو خدمت', desc: '9 بجې تر 9 بجو' },
    email: { title: 'بریښنالیک', desc: 'موږ په 24 ساعتونو کې ځواب ورکوو' },
    address: {
      title: 'پته',
      desc: 'د شنبې څخه تر پنجشنبې، 9 بجې - 6 بجو',
      primary: '12 کور، د کالج لار،',
      secondary: 'دکا فقیر مور، ګوروداسپور، ناتور - 6440'
    }
  },
  form: {
    title: 'یو پیغام لېږئ',
    desc: 'د خپلو تفصیلاتو سره فورمه ډکه کړئ. موږ به په 24 ساعتونو کې تاسو سره اړیکه ونیسو.',
    name: 'نوم',
    email: 'بریښنالیک',
    phone: 'تلیفون',
    subject: 'موضوع',
    message: 'پیغام',
    messagePh: 'خپله پوښتنه یا تبصرې په تفصیل سره ولیکئ...',
    submit: 'لېږل',
    success: 'ستاسو پیغام په بریالیتوب سره لېږل شوی دی. موږ به ژر تاسو سره اړیکه ونیسو.'
  },
  hours: {
    title: 'د دفتر ساعتونه',
    weekdays: 'شنبه - پنجشنبه',
    friday: 'جمعه',
    note: 'په جمعه کې زموږ د دفتر عملیات د عامه رخصتۍ له امله محدود دي'
  },
  social: { title: 'ټولنیز رسنۍ' },
  faq: {
    title: 'د ډیرو پوښتنو ځوابونه',
    subtitle: 'تاسو ممکن خپل ځواب زموږ په مرسته برخه کې ومومئ',
    cta: 'د مرستې مرکز وګورئ'
  }
};

export default contactAf;
